<template>
  <div>
    <div>
      <router-view ></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutIndex',
  data () {
    return {
      active: 0,
      // active3: 0,
      icon: {
        active1: require('@/assets/inhome.png'),
        inactive1: require('@/assets/home.png'),
        active2: require('@/assets/incourse.png'),
        inactive2: require('@/assets/course.png')
        // active3: require('@/assets/in.png'),
        // inactive3: require('@/assets/home.png')
      }
    }
  }
}
</script>

<style>
.van-tabbar{
  z-index: 1  !important;
  margin-bottom: 0 !important;
}
</style>
